import { useEffect, useRef } from 'react';

import { useStore } from '@src/stores-v2';
import BRollService from '@src/services/BRollService';

export const useBRollUploadService = () => {
  const { bRollStore } = useStore();
  const bRollServiceRef = useRef(new BRollService(bRollStore));
  const bRollService = bRollServiceRef.current;

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const { storyId, organizationId } = params;

  useEffect(() => {
    bRollService.initialize({ storyId, organizationId });
  }, [storyId, organizationId]);

  const {
    bRollAssets,
    hasPendingAssets,
    isLoading,
    isOrganization,
    isStory,
    hasUploadingAssets,
    organization,
    story,
    contributor,
  } = bRollStore;

  return {
    // state
    bRollAssets,
    hasPendingAssets,
    isLoading,
    isOrganization,
    isStory,
    hasUploadingAssets,
    organization,
    story,
    contributor,

    // service
    bRollService,
  };
};
